import React from "react";
import { none, useHookstate, type State } from "@hookstate/core";
import EquipmentRow from "./EquipmentRow";
import { Avatar, Chip, Grid, IconButton, Typography } from "@mui/material";
import { useLang } from "~/hooks/useLang";
import { Add } from "@mui/icons-material";
import type { ItemCheckout } from "../../interface";

interface EquipmentsCheckoutProps {
  readonly warehouseId: State<number | null>;
  readonly equipmentsItens: State<ItemCheckout[]>;
}

const itemDefaultValue: ItemCheckout = {
  itemId: null,
  groupId: null,
  quantity: null,
  equipment: null
}


export default function EquipmentsCheckout({ warehouseId, equipmentsItens }: EquipmentsCheckoutProps) {
  const { translate } = useLang()
  const addItem = () => equipmentsItens.merge([itemDefaultValue])
  const removeItem = (index: number) => equipmentsItens[index].set(none)

  return (
    <>
      <Grid container direction="row" justifyContent="flex-start" alignItems="center" gap={2} marginBottom={2}>
        <Typography variant="h6">
          {translate('Equipments')}
        </Typography>
        <Avatar
          onClick={addItem}
          sx={{
            width: 24, 
            height: 24,
            cursor: 'pointer',
            backgroundColor: 'primary.main'
          }}
        >
          <Add />
        </Avatar>
        
      </Grid>
      {equipmentsItens.map((item, index) => (
        <Grid key={index} container xs={12} spacing={2} marginBottom={2}>
          <EquipmentRow
            item={item}
            position={index}
            warehouseId={warehouseId}
            disabledRemoveItem={equipmentsItens.get().length >= 1}
            onRemove={() => removeItem(index)}
          />
        </Grid>
      ))}
    </>
  )
}
